import type Model from "@ember-data/model";
import { helper } from "@ember/component/helper";
import type JournalEventModel from "parog-web/models/journal-event";

export function jeCreator(params: [JournalEventModel]) {
  const je = params[0];
  const creator = je.get("creator");
  if (creator) {
    switch ((creator.constructor as typeof Model).modelName) {
      case "medic": {
        const prefix = creator.get("role") === "doctor" ? "Dr " : "";
        return prefix + creator.get("fullName");
      }
      case "patient":
        return "le patient";
      default:
        return "le programme";
    }
  } else {
    return "le programme";
  }
}

export default helper(jeCreator);
